// extracted by mini-css-extract-plugin
export default {"Reset":"MEbzYgZT7TpCpKDOQeDR","ResetIcon":"rCB_NnFQfD3Fm5GwKtGx"};